var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:none;stroke:#379777;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} .st1{fill:none;stroke:#379777;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:3;} .st2{fill:none;stroke:#379777;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;} .st3{fill:none;} "), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29,12.6V10c0-0.6-0.4-1-1-1h-6.3c-0.3,0.6-1,1-1.7,1s-1.4-0.4-1.7-1H4c-0.6,0-1,0.4-1,1v2.6c1.2,0.7,2,2,2,3.4 s-0.8,2.8-2,3.4V22c0,0.6,0.4,1,1,1h14.3c0.3-0.6,1-1,1.7-1s1.4,0.4,1.7,1H28c0.6,0,1-0.4,1-1v-2.6c-1.2-0.7-2-2-2-3.4 S27.8,13.2,29,12.6z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 20,
    y1: 13,
    x2: 20,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 20,
    y1: 19,
    x2: 20,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11,
    y1: 12,
    x2: 11,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11,
    y1: 19,
    x2: 11,
    y2: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,13h-1.5C9.7,13,9,13.7,9,14.5v0c0,0.8,0.7,1.5,1.5,1.5h1c0.8,0,1.5,0.7,1.5,1.5v0c0,0.8-0.7,1.5-1.5,1.5H10 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -288,
    y: -360,
    className: "st3",
    width: 536,
    height: 680
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceGreen);
export default __webpack_public_path__ + "static/media/priceGreen.65e3517fe4275d30796dc467efae0ad3.svg";
export { ForwardRef as ReactComponent };